import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-circle",
  "use": "icon-circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-circle\">\n\t<path fill=\"none\" d=\"M0 0h24v24H0z\" />\n\t<path d=\"M12,2.5A9.5,9.5,0,1,0,21.5,12,9.5,9.5,0,0,0,12,2.5Zm0,17A7.5,7.5,0,1,1,19.5,12,7.5,7.5,0,0,1,12,19.5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol